import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root',
})
export class EncryDecryService {
  private cost: number = 3;
  // SECURITY: Read encryption key from sessionStorage (not localStorage)
  // sessionStorage is cleared when tab/window closes, reducing XSS attack window
  private key = this.decode(window.sessionStorage.getItem('_temp')!);
  //private key = Math.floor(100000 + Math.random() * 900000).toString();
  constructor() {}
  setKey(key: string) {
    this.key = this.encodeUsingBase64(key);
    return this.key;
  }
  encrypt(text: any) {
    if (!text) return;
    let encryptedText = text;
    for (let i = 0; i < this.cost; i++) {
      encryptedText = this.encryptUsingAES256(encryptedText);
    }
    return encryptedText;
  }
  decrypt(text: any) {
    if (!text) return null;
    try {
      let decryptedText = text;
      for (let i = 0; i < this.cost; i++) {
        decryptedText = this.decryptUsingAES256(decryptedText);
      }
      // If decryptedText is falsy or not valid JSON, return null
      if (!decryptedText) return null;
      return JSON.parse(decryptedText);
    } catch (err) {
      // decryption failed — return null silently
      return null;
    }
  }
  encryptUsingAES256(text: string) {
    const _key = CryptoJS.enc.Utf8.parse(this.encode(this.key));
    const _iv = CryptoJS.enc.Utf8.parse(this.encode(this.key));
    const encrypted = CryptoJS.AES.encrypt(text, _key, {
      keySize: 16,
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }
  decryptUsingAES256(encryptedText: string) {
    try {
      const _key = CryptoJS.enc.Utf8.parse(this.encode(this.key));
      const _iv = CryptoJS.enc.Utf8.parse(this.encode(this.key));

      const decrypted = CryptoJS.AES.decrypt(encryptedText, _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }).toString(CryptoJS.enc.Utf8);
      return decrypted;
    } catch (err) {
      // decryption failed — return empty string silently
      return '';
    }
  }
  encode(text: any) {
    if (!text) return;
    let encodedText = text;

    for (let i = 0; i < this.cost; i++) {
      encodedText = this.encodeUsingBase64(encodedText);
    }

    return encodedText;
  }
  decode(text: any) {
    if (!text) return;
    let decodedText = text;
    for (let i = 0; i < this.cost; i++) {
      decodedText = this.decodeUsingBase64(decodedText);
    }
    return decodedText;
  }
  encodeUsingBase64(text: string) {
    return btoa(text).toString();
  }
  decodeUsingBase64(text: string) {
    return atob(text).toString();
  }
}
